var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoLargeBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 210,
  height: 26,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#logo-large-blue_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#083358",
  d: "M9.352 25.37c4.703-5.65 13.853-12.635 27.251-13.292h.042C18.38 11.979 4.782 20.425 0 25.37z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#083358",
  d: "M19.366 25.369c2.397-4.248 8.565-12.806 17.279-13.293-12.085.592-21.35 6.995-26.28 13.293z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  d: "m10.451 17.585.499-.848 5.134-8.727 3.358 5.706.167.282q2.026-.6 4.094-1.053a59 59 0 0 1 7.8-1.171c-2.337-.067-5.342.102-8.097.66l-.29-.494L16.084 0 8.62 12.683 4.038 20.47l-.906 1.54c2.248-1.673 4.718-3.134 7.22-4.379q.05-.024.1-.049M23.87 21.247l2.426 4.122h4.714l-4.382-7.446c2.186-2.262 4.807-4.148 7.837-5.042-3.08.689-5.818 2.39-8.156 4.496-.686.62-1.34 1.274-1.955 1.948q-.494.54-.964 1.104l.157.264.323.55z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo-large-blue_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#083358",
  d: "m153.797 8.882-7.023 11.975h-5.428l9.466-16.629h6.017l9.49 16.629h-5.452z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  d: "M156.357 16.892h-5.364v3.941h5.364z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#083358",
  d: "m91.424 8.882-7.027 11.975H78.97l9.47-16.629h6.013l9.49 16.629H98.49z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  d: "M93.984 16.892H88.62v3.941h5.364z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#083358",
  d: "M191.373 8.454V4.512h18.624v3.942zm5.115 12.687h-5.115V10.946h18.624v3.605h-13.264v2.605h13.264v3.961zM59.837 8.43H47.186v2.868h11.918v3.881H47.186v5.39h-4.904V4.512h17.555V8.43M66.719 16.688h10.7v3.881H61.808V4.512h4.91zM112.68 20.569h-4.904V8.449h-6.726V4.513h18.352V8.45h-6.726v12.119zM129.697 16.688h10.7v3.881h-15.611V4.512h4.911zM188.913 20.569h-7.191l-9.642-11.68v11.68h-4.903V4.512h7.267l9.574 11.776V4.512h4.891V20.57z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-large-blue_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36.645v25.369H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-large-blue_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42.283 4.228H210v16.913H42.283z"
})))));
export default SvgLogoLargeBlue;